import { render, staticRenderFns } from "./detail_tab_sti.vue?vue&type=template&id=6c7c38e2&scoped=true"
import script from "./detail_tab_sti.vue?vue&type=script&lang=js"
export * from "./detail_tab_sti.vue?vue&type=script&lang=js"
import style0 from "./detail_tab_sti.vue?vue&type=style&index=0&id=6c7c38e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7c38e2",
  null
  
)

export default component.exports